import React, { FC, useCallback } from 'react';
import { useQueryParams } from 'use-query-params';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import { useAutoCompleteController } from '@/controllers';

import AdvancedDropdown from '../../advanced-dropdown';
import { mimirFilterStyles } from '../styles';
import { CohortMemberCohortTypeEnum } from '../../types';

type SLOCohortMimirFilterProps = {
  publicId: string;
  cohort: string;
};

const SLOCohortMimirFilter: FC<SLOCohortMimirFilterProps> = ({ publicId, cohort }) => {
  const { search } = useLocation();

  const parsedQueryParams = qs.parse(search);
  const [, setQuery] = useQueryParams({});

  // Cohort filter
  const handleCohortChange = useCallback((scope: string, value: string[]) => {
    if (!value.length) {
      setQuery({ [scope]: undefined });
      return;
    }
    setQuery({ [scope]: value });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadOptions = useAutoCompleteController('slogroup', {
    formatPlainOption: true,
    typePublicId: publicId,
    mimir: true,
    params: `cohortType=${cohort}`,
  });

  const cohortFilteredValues: string[] = parsedQueryParams[`${cohort}s`]
    ? (parsedQueryParams[`${cohort}s`] as string).split(',')
    : [];

  if (cohort === CohortMemberCohortTypeEnum.Global) {
    return null;
  }

  return (
    <div css={[mimirFilterStyles]}>
      <AdvancedDropdown
        label={cohort}
        onChange={(v: string[]) => handleCohortChange(`${cohort}s`, v)}
        placeholder={`Search by ${cohort}`}
        value={cohortFilteredValues}
        loadOptions={loadOptions}
        isAsync
        isMulti
        isSearchable
        menuWidth={360}
        menuHeight={350}
      />
    </div>
  );
};

export default SLOCohortMimirFilter;
